import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sidebar-one',
  templateUrl: './sidebar-one.component.html',
  styleUrl: './sidebar-one.component.scss'
})
export class SidebarOneComponent {
  @Input() set isCollapsed(value: boolean) {
    this.isSidebarCollapsed = value
  }

  @Input() bgcolor: string = 'transparent';

  isSidebarCollapsed: boolean = false;

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}